import appConfig from 'helper/mapBackendConfig';
import { compileDynamicRoute as compileRoute } from 'helper/string';

export const SPRING_API_BASE_URL = appConfig.env.urlSpringAPI;

const routeProvider = (url: string) => (opts: object = {}) =>
	compileRoute(`${SPRING_API_BASE_URL}/${url}`, opts as any);

export const SpringAPI = {
	overlays: {
		getCustomOverlays: routeProvider('profiles/overlay'),
		putCustomOverlays: routeProvider('profiles/overlay/:id'),
	},
	dashboard: {
		getDashboard: routeProvider('dashboard'),
	},
	mySuccess: {
		getMySuccess: routeProvider('mysuccess'),
		getLevels: routeProvider('mysuccess/levels'),
	},
	notifications: {
		getNotifications: routeProvider('profiles/notifications'),
	},
	profile: {
		getProfile: routeProvider('profiles'),
		putBirthdate: routeProvider('profiles/birthdate'),
		putCoach: routeProvider('profiles/coach/:coach'),
		putFinish: routeProvider('profiles/finish'),
		putGender: routeProvider('profiles/gender'),
		putHealthGoal: routeProvider('profiles/healthgoal'),
		putHeight: routeProvider('profiles/height'),
		putIntensity: routeProvider('profiles/intensity/:intensity'),
		putSlogan: routeProvider('profiles/slogan'),
		putWeight: routeProvider('profiles/weight'),
	},
	tutorial: {
		loadTutorials: routeProvider('profiles/tutorials'),
		updateTutorial: routeProvider('profiles/tutorials/:flag'),
	},
	settings: {
		updateSettings: routeProvider('profiles/settings'),
	},
	program: {
		getPrograms: routeProvider('programs'),
		getActiveProgram: routeProvider('programs/active'),
		postOverwrite: routeProvider('programs/overwrite'),
		postOverwritePreview: routeProvider('programs/overwrite/preview'),
		postStart: routeProvider('programs/start'),
		cancel: routeProvider('programs/:programId'),
		putFinish: routeProvider('programs/:programId/finish'),
	},
	programDay: {
		getProgramDays: routeProvider('programdays/:programId'),
		getCalendar: routeProvider('programdays/:programId/calendar'),
		getToday: routeProvider('programdays/:programId/today'),
		getProgramDay: routeProvider('programdays/:programId/:dayNumber'),
	},
	programItem: {
		putCheck: routeProvider('programitems/:itemId/check'),
		putClose: routeProvider('programitems/:itemId/close'),
	},
	recipeProgramItem: {
		postCustomItem: routeProvider('programitems/:itemId/recipe/custom'),
	},
	sloganProgramItem: {
		putSlogan: routeProvider('programitems/:itemId/slogan'),
	},
	trackingProgramItem: {
		postTracking: routeProvider('programitems/:itemId/tracking'),
		putTracking: routeProvider('programitems/:itemId/tracking'),
		putPostpone: routeProvider('programitems/:itemId/tracking/postpone'),
	},
	workoutProgramItem: {
		putCheck: routeProvider('programitems/:itemId/workout/check'),
		postCustom: routeProvider('programitems/:itemId/workout/custom'),
	},
};
